import {Component, Injector, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {BackgroundData} from '../background/background.component';
import {TagTextData} from '../tag-text/tag-text.component';
import {ButtonOptions} from '../eva-button/eva-button.component';
import {AbstractComponent} from '../abstract.component';
import { Module } from 'projects/common/model/ModuleModel';

export interface BannerWithBackgroundData {
  text_data: TagTextData;
  title: TagTextData;
  button_options: ButtonOptions;
  background_data: BackgroundData;
  button_direction: string;
  text_direction: string;

  // deprecated tom
  text: string;
  tag: string;
  text_color: string;

  link: string;
  link_title: string;
}

@Component({
  selector: 'banner-background',
  template: `
    <p *ngIf="module.title" class="title-content eva-3-h2">{{module.title.text}}</p>
    <div class="banner-wrapper">
      <div class="background-container">
        <img class="background-img"[src]="getMediaUrl()" [alt]="module.data.background_data.alt" loading="lazy"/>
        <div class="background" [ngStyle]="styles"></div>
      </div>
      <div class="banner-content">
        <div class="banner-text-container" [ngClass]="module.data.text_direction ? module.data.text_direction : ''">
          <tag-text *ngIf="module.data.title" [data]="module.data.title"></tag-text>
          <tag-text *ngIf="module.data.text_data" [data]="module.data.text_data"></tag-text>
<!--          deprecated tom-->
          <tag-text *ngIf="module.data.text && !module.data.text_data" [data]="{text: module.data.text, tag: module.data.tag, color: module.data.text_color}"></tag-text>

        </div>
        <eva-button *ngIf="module.data.button_options" class="button-container" [ngClass]="module.data.button_direction ? module.data.button_direction : ''"
                    [options]="module.data.button_options" [moduleId]="getModuleId()" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"></eva-button>
<!--        deprecated tom-->
        <eva-button *ngIf="module.data.link && module.data.link_title && !module.data.button_options" class="button-container" [uniqueId]="module.unique_id"
                    [ngClass]="module.data.button_direction ? module.data.button_direction : ''" [moduleId]="getModuleId()" [moduleIndex]="module.row_number"
                    [options]="{ size: '-md', type: '-primary', link: module.data.link, link_text: module.data.link_title}"></eva-button>
      </div>
    </div>
  `,
  styleUrls: ['./banner-background.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BannerBackgroundComponent extends AbstractComponent implements OnInit {
  private static MODULE_ID = 'BannerBackgroundModule';

  @Input() override module: Module<BannerWithBackgroundData>;

  styles: { [key: string]: string} = {};

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.module.data = this.module.data;
    const backgroundImage: string[] = [];
    if (this.module.data.background_data.direction && this.module.data.background_data.first_color && this.module.data.background_data.second_color) {
      backgroundImage.push(`linear-gradient(${this.module.data.background_data.direction}, ${this.module.data.background_data.first_color}, ${this.module.data.background_data.second_color})`);

    } else if (this.module.data.background_data.first_color) {
      this.styles['background-color'] = this.module.data.background_data.first_color;
    }
    if (backgroundImage.length > 0) {
      this.styles['background-image'] = backgroundImage.join(',');
    }
  }

  getMediaUrl(): string {
    return this.screenType === 'MOBILE' && this.module.data.background_data.picture_mobile ?
        this.module.data.background_data.picture_mobile :
        this.module.data.background_data.picture;
  }

  getModuleId() {
    return BannerBackgroundComponent.MODULE_ID;
  }
}
